import type { WeeklyLearningGuideExportCell } from './weeklyLearningGuideExcelExport';
import type { AnnualEffectiveCell } from './annualTimetable';

export type WeeklyGuideSlotSurface = WeeklyLearningGuideExportCell['slotSurface'];

/**
 * 연간 `deriveAnnualEffectiveCell` 결과 → 주간학습 안내 표면.
 * 자동 비수업(calendar_schedule)도 수동 비수업과 동일하게 `non-class`로 본다.
 */
export function weeklySlotSurfaceFromEffective(
  cell: Pick<AnnualEffectiveCell, 'slotKind' | 'nonClassSource'>
): WeeklyGuideSlotSurface {
  if (cell.slotKind === 'holiday') return 'holiday';
  if (cell.slotKind === 'activity') return 'activity';
  if (cell.slotKind === 'class') return 'class';
  if (cell.slotKind === 'non_class') return 'non-class';
  return 'class';
}

/** 연간시간표·주간학습 안내 공통 비수업·활동 배경 클래스 */
export function weeklyGuideSurfaceClassNames(surface: WeeklyGuideSlotSurface): string {
  if (surface === 'holiday') return 'cp-weekly-learning-guide-cell--surface-holiday';
  if (surface === 'activity') return 'cp-weekly-cell-activity-hatch';
  // calendar-non-class: 예전 export 호환 — 화면·PDF는 수동 비수업과 동일 빗금
  if (surface === 'non-class' || surface === 'calendar-non-class') {
    return 'cp-weekly-cell-no-class cp-weekly-cell-unused-kind';
  }
  return '';
}
